<footer style="margin:0;">
  <div class="p-grid" style="padding-top:5px;">
    <div class="p-col-12 p-md-12 p-lg-4 terms-policies" style="padding-left:25px!important;">
      <a href="{{RouteLink.OneLynkTermsAndConditions}}" target="_blank" style="color:#336699!important;">Terms of Use</a> and
      <a href="{{RouteLink.OneLynkPrivacyPolicy}}" target="_blank" style="color:#336699!important;">Privacy Policy</a>
    </div>
    <div class="p-col-12 p-md-12 p-lg-4">&copy;2022 AtWork Systems. All Rights Reserved.</div>
    <div *ngIf="user?.authenticated" class="p-col-12 p-md-12 p-lg-4 connect-button" style="position: relative;top:5px;">
      <div>
        <button pButton (click)="initiateSupport()" icon="fa fa-comment-o" class="secondary-action" pTooltip="Chat with us!" tooltipPosition="bottom" label="&nbsp;Chat Support">
        </button>
        <div *ngIf="user?.info?.orgId === DefaultOrg.OrgId && user.info?.orgId" (click)="initiateSupport()" class="chatsupport-badge" style="position: relative;top:5px;left:0;">
          {{app.supportRequestCount}}</div>
      </div>
    </div>
  </div>
</footer>
